import classNames from 'classnames';
import { isEqual } from 'lodash';
import * as React from 'react';

import { Bem } from '../../service/Bem/Bem';
import { PcodeLoader, PcodeRenderer } from '../../service/Pcode/Pcode';
import { PcodeRenderData } from '../../typings/pcode';

interface PcodePreviewProps {
    cls?: string;
    data: PcodeRenderData;
}

export class PcodePreview extends React.PureComponent<PcodePreviewProps> {
    private renderNode = React.createRef<HTMLDivElement>();
    private pcodeRenderer: PcodeRenderer | undefined;

    componentDidMount() {
        PcodeLoader.loadScript().then(() => {
            this.pcodeRenderer = new PcodeRenderer();

            const renderNode = this.renderNode.current;

            if (renderNode) {
                this.pcodeRenderer.show(renderNode, this.props.data);
            }
        });
    }

    componentDidUpdate(prevProps: PcodePreviewProps) {
        if (!isEqual(prevProps.data, this.props.data)) {
            const renderNode = this.renderNode.current;

            if (renderNode && this.pcodeRenderer) {
                this.pcodeRenderer.update(renderNode, this.props.data);
            }
        }
    }

    render() {
        const { cls } = this.props;

        return (
            <div
                key={'pcode-preview-key'}
                className={classNames(cls, Bem.cls('pcode-preview'))}
                ref={this.renderNode}
            />
        );
    }
}
